import React, { createContext, useContext } from 'react';
import { useDataProvider } from '../DataProvider';

const EntityPermissionContext = createContext();

function EntityPermissionProvider({ permissionApiUrl, children }) {
  const value = React.useMemo(() => ({ permissionApiUrl }), [permissionApiUrl]);
  return (
    <EntityPermissionContext.Provider value={value}>
      {children}
    </EntityPermissionContext.Provider>
  );
}

export const useEntityPermission = () => {
  const { permissionApiUrl } = useContext(EntityPermissionContext);
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get } = useDataProvider(provider);

  const getPermission = async entity => {
    let status = '';

    if (entity?.status) {
      status = `&entityStatus=${entity.status}`;
    }
    const url = `${permissionApiUrl}?entityName=${entity.name}${status}`;

    const response = await get(url);
    if (response?.ok) {
      return response?.data;
    }
    return null;
  };

  const getPermissions = async entities => {
    if (!entities || entities.length === 0) return [];
    const permissions = await Promise.all(entities.map(getPermission));
    return permissions;
  };

  const isReadOnly = (permission, value = null) => {
    const pureRead = ['READ', 'READ_ONLY'].includes(permission);
    if (pureRead) return true;
    const derivedRead =
      ['WRITE_ONCE'].includes(permission) && value !== '' && value;
    if (derivedRead) return true;
    return false;
  };

  const isHidden = permission => {
    const pureHide = ['HIDDEN'].includes(permission);
    return pureHide;
  };

  return {
    isHidden,
    isReadOnly,
    permissionApiUrl,
    getPermission,
    getPermissions,
  };
};

export default EntityPermissionProvider;
